(function ($) {
  $.fn.selectpicker.defaults = {
    noneSelectedText: '何もが選択した',
    noneResultsText: '\'{0}\'が結果を返さない',
    countSelectedText: '{0}/{1}が選択した',
    maxOptionsText: ['限界は達した({n}{var}最大)', '限界をグループは達した({n}{var}最大)', ['アイテム', 'アイテム']],
    selectAllText: '全部を選択する',
    deselectAllText: '何も選択しない',
    multipleSeparator: ', '
  };
})(jQuery);
